import { render, staticRenderFns } from "./my-group.vue?vue&type=template&id=941df1d0&scoped=true&"
import script from "./my-group.vue?vue&type=script&lang=js&"
export * from "./my-group.vue?vue&type=script&lang=js&"
import style0 from "./my-group.vue?vue&type=style&index=0&id=941df1d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941df1d0",
  null
  
)

export default component.exports